import { clearErrors, clearVariationsCombinationErrors } from '../../errors';
import { getError } from '..';
import { getSize } from '../../iterable/getSize';

import { COMBINATIONS, INFLUENCE, VARIANTS } from '../../../constants/variations';
import { ERROR, VALUE } from '../../../constants/product';
import { ATTRIBUTE } from '../../../constants/attributes';
import { FORM } from '../../../constants/forms';

const NO_CHANGES = 'no_changes';

export default function processingProfile({ actions, operation, product: source, shopData }) {
  let product = source;
  const size = getSize(product.getIn([FORM.VARIATIONS, COMBINATIONS]));

  function findVariantById(variantId) {
    return function find(variant) {
      return variant.get('id') === variantId;
    };
  }

  function findCombinationById(combinationId) {
    return function find(combination) {
      return combination.get('id') === combinationId;
    };
  }

  function updateShipping(productShipping, valueIndex) {
    const productValue = productShipping.getIn([ATTRIBUTE.PROCESSING_PROFILE, VALUE]) || null;
    const value = operation.getIn(['value', valueIndex, 'value']);

    if (value === productValue) return NO_CHANGES;

    return getError({ shopData, type: ATTRIBUTE.PROCESSING_PROFILE, value })
      ? ERROR
      : productShipping.setIn([ATTRIBUTE.PROCESSING_PROFILE, VALUE], value);
  }

  function updateCombination(combination, valueIndex) {
    const productValue = combination.get(ATTRIBUTE.PROCESSING_PROFILE) || null;
    const value = operation.getIn(['value', valueIndex, 'value']);

    if (value === productValue) return NO_CHANGES;

    return getError({ shopData, type: ATTRIBUTE.PROCESSING_PROFILE, value })
      ? ERROR
      : combination.set(ATTRIBUTE.PROCESSING_PROFILE, value);
  }

  for (let valueIndex = 0; valueIndex < getSize(operation.get('value')); valueIndex++) {
    const operationOfferingId = operation.getIn(['value', valueIndex, 'offeringId'], null);
    const operationCombination = operation.getIn(['value', valueIndex, 'combination'], null);

    if (operationCombination === null && operationOfferingId === null) {
      if (getSize(product.getIn([FORM.VARIATIONS, INFLUENCE, ATTRIBUTE.PROCESSING_PROFILE])) === 0) {
        const productShipping = updateShipping(product.get(FORM.SHIPPING), valueIndex);

        if (productShipping === ERROR) return source;

        if (productShipping !== NO_CHANGES) {
          product = clearErrors({
            errors: [ATTRIBUTE.PROCESSING_PROFILE],
            path: FORM.SHIPPING,
            product: product.set(FORM.SHIPPING, productShipping),
          });
        }
      }

      if (size) {
        for (let combinationIndex = 0; combinationIndex < size; combinationIndex++) {
          const combination = updateCombination(
            product.getIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex]),
            valueIndex
          );

          if (combination === ERROR) return source;

          if (combination === NO_CHANGES) continue;

          product = clearVariationsCombinationErrors({
            errors: [ATTRIBUTE.PROCESSING_PROFILE],
            combinationIndex,
            product: product.setIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex], combination),
          });
        }
      }
    } else if (operationCombination !== null) {
      if (size) {
        const optionId = operationCombination.get('optionId');
        const variationId = operationCombination.get('variationId');
        const variantIndex = product.getIn([FORM.VARIATIONS, VARIANTS]).findIndex(findVariantById(variationId));

        if (variantIndex === -1) return source;

        for (let combinationIndex = 0; combinationIndex < size; combinationIndex++) {
          let combination = product.getIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex]);

          if (combination.getIn(['options', variantIndex, 'optionId']) !== optionId) continue;

          combination = updateCombination(combination, valueIndex);

          if (combination === ERROR) return source;

          if (combination === NO_CHANGES) continue;

          product = clearVariationsCombinationErrors({
            errors: [ATTRIBUTE.PROCESSING_PROFILE],
            combinationIndex,
            product: product.setIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex], combination),
          });
        }
      }
    } else if (operationOfferingId !== null) {
      if (size) {
        const combinationIndex = product
          .getIn([FORM.VARIATIONS, COMBINATIONS])
          .findIndex(findCombinationById(operationOfferingId));

        if (combinationIndex === -1) return source;

        const combination = updateCombination(
          product.getIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex]),
          valueIndex
        );

        if (combination === ERROR) return source;

        if (combination === NO_CHANGES) continue;

        product = clearVariationsCombinationErrors({
          errors: [ATTRIBUTE.PROCESSING_PROFILE],
          combinationIndex,
          product: product.setIn([FORM.VARIATIONS, COMBINATIONS, combinationIndex], combination),
        });
      }
    }
  }

  return { actions, product };
}
